import { render, staticRenderFns } from "./OldVideos.vue?vue&type=template&id=796ca221&scoped=true&"
import script from "./OldVideos.vue?vue&type=script&lang=js&"
export * from "./OldVideos.vue?vue&type=script&lang=js&"
import style0 from "./OldVideos.vue?vue&type=style&index=0&id=796ca221&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ca221",
  null
  
)

export default component.exports